import React from 'react';
import { useAssets } from '../../hooks/useAssets';
import type { CustomFieldConfig } from '../../types/category';

interface AssetFieldSelectorProps {
  field: CustomFieldConfig;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const AssetFieldSelector: React.FC<AssetFieldSelectorProps> = ({
  field,
  value,
  onChange,
  error
}) => {
  const { data: assets, isLoading } = useAssets({ 
    assetTypeId: field.assetTypeId, 
    activeOnly: true 
  });

  return (
    <div>
      <label htmlFor={`asset-${field.fieldId}`} className="block text-sm font-medium text-gray-700 mb-1">
        {field.fieldName} {field.required && <span className="text-red-500">*</span>}
      </label>
      <select
        id={`asset-${field.fieldId}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={isLoading}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          error ? 'border-red-500' : 'border-gray-300'
        } ${isLoading ? 'bg-gray-100' : ''}`}
      >
        <option value="">
          {isLoading ? 'Cargando...' : `Seleccionar ${field.fieldName.toLowerCase()}`}
        </option>
        {assets?.map((asset) => (
          <option key={asset.assetId} value={asset.assetId}>
            {asset.displayName}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default AssetFieldSelector;
